module.exports = __webpack_public_path__ + "static/media/sq_biteship.112f06f7.png";